
<button matButton="outlined"
  class="inline mb-2"
  style="background-color: #ff9933; color: white;"
  (click)="goBack()">
  Back
</button>

<h3 class="title-center pt-2">Add Custom SQL Query</h3>
<div class="pb-2 ps-2" style="float: right;">
  <button matButton="elevated" (click)="toggleCancelEditIdentifier()">Cancel</button>
</div>

<div class="flexWrap">

    <div class="flexLeftCol">
      @if (!isInTab && !client)
      {
        <mat-form-field appearance="fill" class="med-wide-text-box">
          <mat-label>Client</mat-label>
          <input type="text" matInput [matAutocomplete]="auto" [formControl]="clientFormControl">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
            (optionSelected)="selectClient($event.option.value)" [displayWith]="displayFnClient">
            <mat-option *ngFor="let option of filteredClients | async" [value]="option">
              {{option.clientDisplayName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      }

      @if (client)
      {
        <div class="flexFormLine">
          @if (isInTab) {
            <h4>Client: {{client.clientDisplayName}}</h4>
          }
          @else {
            <h2>Client: {{client.clientDisplayName}}</h2>
            <div class="pb-2">
              <button matButton="elevated" (click)="editClient()">Change</button>
            </div>
          }
        </div>
        @if (!isInTab && integration == null)
        {
          <mat-form-field appearance="fill" class="med-wide-text-box">
            <mat-label>Integration</mat-label>
            <input type="text" matInput [matAutocomplete]="auto" [formControl]="integrationFormControl">
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
              (optionSelected)="selectIntegration($event.option.value)" [displayWith]="displayFnIntegration">
              <mat-option *ngFor="let option of filteredIntegrations | async" [value]="option">
                {{option.name}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        }
      }

      @if (integration != null)
      {
        <div class="flexFormLine">
          <h5>Integration: {{integration.name}}</h5>
          @if (!isInTab) 
          {
            <div class="pb-2">
              <button matButton="elevated" (click)="editIntegration()">Change</button>
            </div>
          }
        </div>
      }

      @if (integration != null && !hasQueryType)
      {
        <mat-form-field appearance="fill" class="med-wide-text-box">
          <mat-label>Query Type</mat-label>
          <input type="text" matInput [matAutocomplete]="auto" [formControl]="queryTypeFormControl">
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
            (optionSelected)="selectQueryType($event.option.value)" [displayWith]="displayFnQueryType">
            <mat-option *ngFor="let option of filteredQueryTypes | async" [value]="option">
              {{option.queryTypeName}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      }

      @if (integration != null && hasQueryType)
      {
        <div class="flexFormLine">
          <h5>QueryType: {{queryType.queryTypeName}}</h5>
          <div class="pb-2">
            <button matButton="elevated" (click)="editQueryType()">Change</button>
          </div>
        </div>
      }
      <br/>
      @if (integration != null && hasQueryType)
      {
        <mat-form-field class="example-full-width" appearance="fill">
          <mat-label>Query Name</mat-label>
          <input matInput [(ngModel)]="queryName">
        </mat-form-field>
      }
    </div>

  @if (queryType)
  {
    <div class="flexRightCol">
      <app-monaco-editor #monaco
          (textChange)="monacoData = $event"
          [editorData]="monacoData"
          [lang]="'sql'"
          [editAccess]="true"
      ></app-monaco-editor>
      <br/>
      <div class="submit">
        <button id="btnSaveQuery"
          matButton="elevated" (click)="addCustomQuery()" [color]="primary" [disabled]="savingQuery">
          Add Custom Query
        </button>
        @if(savingQuery){
          <div>
            <app-lt-spinner></app-lt-spinner>
          </div>
        }
      </div>
    </div>
  }

</div>


<app-lt-page-loading-message [loading]="pageLoading" [loadingFailed]="!pageLoading && !queryTypes"></app-lt-page-loading-message>
